import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ViewByOption } from 'typings/viewBy'

const initialState: ViewByOption[] = []

const selectedViewBySlices = createSlice({
  name: 'selectedViewBy',
  initialState,
  reducers: {
    selectViewBy(state, action: PayloadAction<ViewByOption>) {
      return state.filter(({ id }) => id !== action.payload.id).concat(action.payload)
    },
    setAllSelectedViewBy(state, action: PayloadAction<ViewByOption[]>) {
      return action.payload ?? initialState
    },
  },
})

export const { selectViewBy, setAllSelectedViewBy } = selectedViewBySlices.actions

export default selectedViewBySlices.reducer
